import React from "react";
import "./lokasi.scss";
import mapsimage from "../../Media/Maps_Desktop.png";
import mobilemaps from "../../Media/Maps_Mobile.png";

const lokasi = () => {
  return (
    <div id="lokasi" className="lokasi">
      <div className="judul1">Location </div>
      <div className="maps-lokasi">
        <img className="img-lokasi-dekstop" src={mapsimage} alt="maps" />
        <img className="img-lokasi-mobile" src={mobilemaps} alt="maps" />
      </div>
    </div>
  );
};

export default lokasi;
